import { ProductFilters } from "../..";

export default function FilterMobileView({ filterData, prices }) {
  return (
    <>
      <input type="checkbox" id="filter-modal" className="modal-toggle" />
      <div className="modal h-[100dvh] w-screen">
        <div
          className={`modal-box relative min-h-screen w-screen rounded-none`}
        >
          <div className="flex justify-between items-center mb-9">
            <p className="text-[#414E5F] text-[1.063rem] font-semibold">
              Filter By
            </p>
            <label htmlFor="filter-modal" className="font-bold text-lg">
              ✕
            </label>
          </div>

          <div className="pb-3">
            <ProductFilters filterData={filterData} prices={prices} />
          </div>
        </div>
      </div>
    </>
  );
}
